import React from 'react';

const MAX_ATTEMPTS = 3;

export const createLazyWithRetries = ({
  maxAttempts = MAX_ATTEMPTS,
  onRetry,
  onRetryFailure,
}: {
  maxAttempts?: number;
  onRetry?: ({
    attemptNumber,
    rootError,
  }: {
    attemptNumber: number;
    rootError: unknown;
  }) => void;
  onRetryFailure?: ({
    attemptNumber,
    error,
    rootError,
  }: {
    attemptNumber: number;
    error: unknown;
    rootError: unknown;
  }) => void;
}) => {
  const lazyWithRetries: typeof React.lazy = (importer) => {
    const retryImport = async () => {
      try {
        return await importer();
      } catch (error: unknown) {
        for (
          let attemptNumber = 1;
          attemptNumber < maxAttempts + 1;
          attemptNumber++
        ) {
          try {
            if (onRetry) {
              onRetry({ attemptNumber, rootError: error });
            }

            return await importer();
          } catch (e) {
            if (onRetryFailure) {
              onRetryFailure({ attemptNumber, error: e, rootError: error });
            }
          }
        }

        throw error;
      }
    };
    return React.lazy(retryImport);
  };

  return lazyWithRetries;
};
